export default __webpack_public_path__ + "static/media/white-logo.4b06ee80.svg";